/*
 * Kompakte Produktgalerie: zeigt nur ein Bild, navigiert per Pfeilen + Punkten.
 * Aktiv nur bei gallery_layout == 'compact_dots' (Wrapper .product--compact_dots).
 * Reitet auf der vorhandenen media-gallery (setActiveMedia togglet .is-active);
 * keine Abhängigkeit zur Thumbnail-/Swiper-Logik.
 */
(function () {
  function arrowBtn(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'cgallery-arrow cgallery-arrow--' + dir;
    b.setAttribute('aria-label', dir === 'prev' ? 'Vorheriges Bild' : 'Nächstes Bild');
    b.innerHTML =
      '<svg viewBox="0 0 10 6" fill="none" aria-hidden="true">' +
      '<path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return b;
  }

  function initGallery(gallery) {
    if (gallery.dataset.cgInit) return;
    var list = gallery.querySelector('.product__media-list');
    if (!list) return;

    var items = function () {
      return Array.prototype.slice.call(list.querySelectorAll('.product__media-item'));
    };
    var all = items();
    if (all.length === 0) return;
    gallery.dataset.cgInit = '1';

    if (!list.querySelector('.product__media-item.is-active')) all[0].classList.add('is-active');

    var mg = gallery.tagName === 'MEDIA-GALLERY' ? gallery : gallery.querySelector('media-gallery');

    function activeIndex() {
      var a = items();
      for (var i = 0; i < a.length; i++) {
        if (a[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    function go(i) {
      var a = items();
      if (a.length === 0) return;
      i = ((i % a.length) + a.length) % a.length;
      var target = a[i];
      var id = target.getAttribute('data-media-id');
      if (mg && typeof mg.setActiveMedia === 'function' && id) {
        mg.setActiveMedia(id, false);
      } else {
        a.forEach(function (x) { x.classList.remove('is-active'); });
        target.classList.add('is-active');
      }
      sync();
    }

    // Pfeile + Punkte/Zähler werden in die slider-component gehängt (gültiges
    // Markup: keine <button>-Kinder in der <ul>). Positioniert per CSS.
    var stage = list.closest('slider-component') || list.parentNode || gallery;

    // Pfeile (in die Bildfläche)
    var prev = arrowBtn('prev');
    var next = arrowBtn('next');
    prev.addEventListener('click', function () { go(activeIndex() - 1); });
    next.addEventListener('click', function () { go(activeIndex() + 1); });
    stage.appendChild(prev);
    stage.appendChild(next);

    // Punkte
    var dots = document.createElement('div');
    dots.className = 'cgallery-dots';
    function buildDots() {
      dots.innerHTML = '';
      items().forEach(function (it, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'cgallery-dot';
        d.setAttribute('aria-label', 'Bild ' + (i + 1));
        d.addEventListener('click', function () { go(i); });
        dots.appendChild(d);
      });
    }
    buildDots();
    stage.appendChild(dots);

    // Zähler-Fallback für viele Bilder (Punkte würden mehrzeilig/unleserlich)
    var DOTS_MAX = 8;
    var counter = document.createElement('div');
    counter.className = 'cgallery-counter';
    stage.appendChild(counter);

    function sync() {
      var a = items();
      if (dots.children.length !== a.length) buildDots();
      var idx = activeIndex();
      var dl = dots.querySelectorAll('.cgallery-dot');
      for (var j = 0; j < dl.length; j++) dl[j].classList.toggle('is-active', j === idx);
      var multi = a.length > 1;
      var manyImages = a.length > DOTS_MAX;
      prev.style.display = multi ? '' : 'none';
      next.style.display = multi ? '' : 'none';
      dots.style.display = multi && !manyImages ? '' : 'none';
      counter.style.display = multi && manyImages ? '' : 'none';
      if (multi && manyImages) counter.textContent = (idx + 1) + ' / ' + a.length;
    }

    // Touch-Swipe (Mobile). WICHTIG: Listener laufen in der CAPTURE-Phase, damit
    // sie die Touch-Events sicher sehen, auch wenn Kind-Elemente (slider-component
    // / modal-opener) sie in der Bubble-Phase per stopPropagation abfangen.
    // Richtung wird beim ersten klaren Move entschieden (dx vs dy); vertikale
    // Gesten scrollen normal (touch-action: pan-y per CSS). Ein erkannter Wisch
    // unterdrückt den Folge-Klick, sonst öffnet der Zoom-Layer.
    var tsX = 0, tsY = 0, tracking = false, decided = false, horizontal = false, swiped = false;
    var LOCK = 10;  // ab hier wird die Richtung entschieden
    var GO = 30;    // Mindest-Distanz für Bildwechsel
    function onStart(e) {
      var t = e.touches && e.touches[0];
      if (!t || e.touches.length !== 1 || items().length < 2) { tracking = false; return; }
      tsX = t.clientX; tsY = t.clientY;
      tracking = true; decided = false; horizontal = false; swiped = false;
    }
    function onMove(e) {
      if (!tracking) return;
      var t = e.touches && e.touches[0];
      if (!t) return;
      var dx = t.clientX - tsX, dy = t.clientY - tsY;
      if (!decided && (Math.abs(dx) > LOCK || Math.abs(dy) > LOCK)) {
        decided = true;
        horizontal = Math.abs(dx) > Math.abs(dy);
      }
    }
    function onEnd(e) {
      if (!tracking) return;
      tracking = false;
      if (!decided || !horizontal) return;
      var t = e.changedTouches && e.changedTouches[0];
      if (!t) return;
      var dx = t.clientX - tsX;
      if (Math.abs(dx) < GO) return;
      swiped = true;
      go(activeIndex() + (dx < 0 ? 1 : -1)); // links wischen = nächstes Bild
    }
    list.addEventListener('touchstart', onStart, { passive: true, capture: true });
    list.addEventListener('touchmove', onMove, { passive: true, capture: true });
    list.addEventListener('touchend', onEnd, { passive: true, capture: true });
    // Folge-Klick nach einem Wisch abfangen (sonst öffnet der modal-opener)
    list.addEventListener('click', function (e) {
      if (swiped) { e.preventDefault(); e.stopPropagation(); swiped = false; }
    }, true);

    // Auf Variantenwechsel reagieren (setActiveMedia ändert .is-active)
    var mo = new MutationObserver(function () { sync(); });
    items().forEach(function (it) {
      mo.observe(it, { attributes: true, attributeFilter: ['class'] });
    });
    sync();
  }

  function initAll() {
    document.querySelectorAll('.product--compact_dots media-gallery').forEach(initGallery);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
